var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 3.33322C10.7951 3.33322 3.33285 10.7955 3.33285 20.0006C3.33285 29.2057 10.7951 36.668 20.0002 36.668C29.2054 36.668 36.6676 29.2057 36.6676 20.0006C36.6676 10.7955 29.2054 3.33322 20.0002 3.33322ZM20.0002 -0.000256539C8.95407 -0.000256539 -0.00062275 8.95443 -0.00062275 20.0006C-0.00062275 31.0468 8.95407 40.0015 20.0002 40.0015C31.0464 40.0015 40.0011 31.0468 40.0011 20.0006C40.0011 8.95443 31.0464 -0.000256539 20.0002 -0.000256539Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 31.0015C18.8957 31.0015 18.0002 30.106 18.0002 29.0015L18.0002 17.0015C18.0002 15.8969 18.8957 15.0015 20.0002 15.0015C21.1048 15.0015 22.0002 15.8969 22.0002 17.0015L22.0002 29.0015C22.0002 30.106 21.1048 31.0015 20.0002 31.0015Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 11.0015C18.0002 9.89689 18.8957 9.00146 20.0002 9.00146C21.1048 9.00146 22.0002 9.89689 22.0002 11.0015C22.0002 12.106 21.1048 13.0015 20.0002 13.0015C18.8957 13.0015 18.0002 12.106 18.0002 11.0015Z",
    fill: "black"
  })));
};
export default SvgInfo;